import React, { useMemo } from 'react';
import './StatusSlider.css';

const StatusSlider = ({value, onChange, min = 1, max = 5, labels = [], disabled = false, className = ''}) => {
    // Generate default labels if none provided
    const steps = useMemo(() => {
        if (labels.length > 0) return labels;
        const autoLabels = [];
        for (let i = min; i <= max; i++) {
            autoLabels.push({ value: i, label: i.toString() });
        }
        return autoLabels;
    }, [min, max, labels]);

    const handleChange = (e) => {
        if (!disabled) onChange(Number(e.target.value));
    }

    return (
        <div className={`status-slider-container ${disabled ? 'disabled' : ''} ${className}`}>
            <div className="slider-track-wrapper">
                <input
                    type="range"
                    min={min}
                    max={max}
                    step={1}
                    value={value}
                    onChange={handleChange}
                    disabled={disabled}
                    className="slider-input"
                />
            </div>
            <div className="slider-labels">
                {steps.map((step, index) => {
                    // Calculate position for the label to center it under the step
                    // We use flexbox space-between usually, but for precise aligning:
                    const isSelected = step.value === value || (typeof step === 'string' && index + min === value);
                    const displayLabel = typeof step === 'object' ? step.label : step;
                    const stepValue = typeof step === 'object' ? step.value : index + min;

                    return (
                        <div
                            className={`slider-label-item ${isSelected ? 'active' : ''}`}
                            onClick={() => handleChange({ target: { value: stepValue } })} // Click label to select
                        >
                            {displayLabel}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default StatusSlider;